export default {
  path: 'contacts',
  name: 'publisher/contacts',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "publisher-show-contacts" */ './Contacts')
}
